import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { userLeaveAPI } from '../../../api/accountAPI';
import { URL } from '../../../constant';
import { useAlert, useLoading, useUserInfo } from '../../../hooks';
import useAmplitude from '../../../hooks/useAmplitude';

function Leave() {
  const history = useHistory();
  const { t } = useTranslation();
  const { info } = useUserInfo();
  const { setAmplitudeLog } = useAmplitude();
  const { setLoading, clearLoading } = useLoading();
  const [Alert, CodeAlert] = useAlert();
  const [agree, setAgree] = useState(false);
  const [pwView, setPwView] = useState(false);
  const [pw, setPw] = useState("");
  const [email, setEmail] = useState(localStorage.getItem("access.email"))
  useEffect(() => {
    if (!info) return;
    setEmail(info.userEmail);
  }, [info])

  const handleChange = useCallback((e) => {
    const name = e.target.name;
    if (name === 'agree') {
      const checked = e.target.checked;
      setAgree(checked);
    } else if (name === 'pw') {
      const value = e.target.value;
      setPw(value);
    }
  }, [agree]);

  const handlePwIsView = useCallback(() => {
    setPwView(!pwView);
  }, [pwView]);

  const userLeaveAPICall = useCallback(async () => {
    setLoading({ isShowSpinner: true, spinnerType: '1' });
    if (!info) return;

    let msg = '';

    if (!pw) msg = t("front_message.msg034");
    else if (!agree) msg = t("front_message.msg035");

    if(msg) {
      Alert(msg);
      clearLoading();
      return;
    }

    try {
      const { userId } = info;
      const resp = await userLeaveAPI({
        mbrId: userId,
        pw,
      });

      if (resp?.code === 'S000000') {
        setAmplitudeLog({ eventCategory: 'account', eventName: '회원 탈퇴' });
        history.push(URL.ACCOUNT.LEAVE_SUCCESS);
      } else {
        if (resp?.code && resp.code === 'S002016') {
          Alert(t("MY_03_05.msg012"));
          return;
        } else {
          CodeAlert(resp.resp);
          return;
        }
      }
    } catch (error) {
      console.log("###### userLeaveAPICall: ", error);
    } finally {
      clearLoading();
    }

    
  }, [pw, info, agree])

  return (
    <React.Fragment>
      <div className="header_top gb bg_sky">
        <div className="inner">
          <div className="btns_wrap cls">
            <div className="app_btn">
              <button 
                className="btn_exit" 
                type="button"
                onClick={() => history.goBack()}
              >
                <img src="./static/images/icon/btn_back.svg" alt="" />
              </button>
            </div>
            <div className="tit_gm center_tit24">MY</div>
          </div>
        </div>
      </div>

      <div className="layout-def with_header bg_gray bg_my m_pt64 gb">
        <div className="container">
          <div className="inner">
            <div className="w672 w672_tb m_pd0 withdraw">
              <div className="top_image">
                <img src="./static/images/common/cha_my_aimessage_th_01.svg" alt="" />
              </div>
              <div className="box">
                <div className="upper">
                  <h1>{t("MY_03_05.msg001")}</h1>
                  <div className="txt1">{t("MY_03_05.msg002")}</div>
                  <div className="blue_box">
                    <ul dangerouslySetInnerHTML={{__html: t("MY_03_05.msg003")}}/>
                  </div>
                  <div className="chk_cont">
                    <div className="custom-radio-wrap">
                      <input
                        type="checkbox"
                        id="input-chk1" 
                        checked={agree}
                        name="agree"
                        onChange={handleChange}
                      />
                      <label htmlFor="input-chk1">{t("MY_03_05.msg004")}</label>
                    </div>
                  </div>
                </div>
                <div className="lower">
                  <div className="title" dangerouslySetInnerHTML={{__html: t("MY_03_05.msg005")}}/>
                  <div className="input_cont">
                    <dl className="cls">
                      <dt>{t("MY_03_05.msg006")}</dt>
                      <dd><div className="mail">{email}</div></dd>
                    </dl>
                    <dl className="cls password">
                      <dt>{t("MY_03_05.msg007")}</dt>
                      <dd>
                        <input
                          type={pwView ? 'text' : 'password'}
                          placeholder={t("MY_03_05.msg008")}
                          name="pw"
                          onChange={handleChange}
                        />
                        <div className="r_area">
                          <button type="button" onClick={handlePwIsView}>
                            {
                              pwView
                                ? <img src="./static/images/icon/btn_join_eye_on.svg" alt="" />
                                : <img src="./static/images/icon/btn_join_eye_off.svg" alt="" />
                            }
                          </button>
                        </div>
                      </dd>
                    </dl>
                  </div>
                </div>
              </div>
              <div className="bottom_btn_wrap cls">
                <div className="left">
                  <button
                    type="button"
                    className="btn-small btn-gray btn-left"
                    onClick={() => history.goBack()}
                  >
                    <span>{t("MY_03_05.msg013")}</span>
                  </button>
                </div>
                <div className="right">
                  <button
                    className="btn btn-dark"
                    onClick={userLeaveAPICall}
                  >
                    {t("MY_03_05.msg010")}
                  </button>
                </div>
              </div>
            </div>
            <div className="pc-footer">
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Leave;